export default __webpack_public_path__ + "static/media/linkedin-icon.272b8515.svg";